import { type ApiOrder } from '@Model';
import { EditFrameShell } from '@synqo/frontend-component-library';
import { ContainerHistoryCard, ContainersAtSiteCard, type SiteCorrection } from '../Containers';
import { type OrderContainers } from './useOrderContainers';

interface IProps {
    order: ApiOrder;
    containers: OrderContainers;
    openOrder: (orderId: string) => void;
    correction: SiteCorrection | undefined;
}

// @ai-generated 2026-10-22T10:53:17+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function OrderSidePanel({ order, containers, openOrder, correction }: IProps) {
    const { containersAtSite, planning, containerTypes, siteCardActions } = containers;

    return (
        <EditFrameShell.SidePanel label="Container" visible={!containersAtSite.isEmpty}>
            <ContainersAtSiteCard
                standing={containersAtSite.standing}
                planned={containersAtSite.planned}
                plannedFailed={containersAtSite.plannedFailed}
                failure={containersAtSite.stockFailure}
                afterSave={containersAtSite.afterSave}
                correction={correction}
                orderId={order.id}
                orderNumber={order.number}
                containerActions={order.container_actions}
                containerTypes={containerTypes}
                actions={siteCardActions}
                planning={planning.isPlanning}
                onPlan={(action, source) => void planning.plan(action, source)}
                onOpenOrder={openOrder}
            />
            <ContainerHistoryCard
                onOpenOrder={openOrder}
                entries={containersAtSite.history}
                failed={containersAtSite.historyFailed}
            />
        </EditFrameShell.SidePanel>
    );
}
